// SPDX-License-Identifier: AGPL-3.0-or-later

export const PRODUCT_NAME = 'Micup';
// Micup premium name: "Micup Plus" wherever upstream shows its premium product name.
export const PREMIUM_PRODUCT_NAME = `${PRODUCT_NAME} Plus`;
export const PREMIUM_PRODUCT_FULL_NAME = PREMIUM_PRODUCT_NAME;
export const DEFAULT_PREMIUM_PRODUCT_NAME = 'Plus';
